module.exports = __webpack_public_path__ + "static/app-shot-n-1-4-3755a818af619953f5e1e7706b583679.png";